'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EventGroups = require('../constants/EventGroups');

var _EventGroups2 = _interopRequireDefault(_EventGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FIREALARM_PREOADED_EVENTS_KEY = '_preLoadEvents';

var Events = function () {
  function Events() {
    var _this = this;

    _classCallCheck(this, Events);

    this.events = {};
    this.eventMarkers = {};

    _EventGroups2.default.keys().forEach(function (key) {
      var group = _EventGroups2.default[key];

      _this.events[group] = [];
    });
  }

  _createClass(Events, [{
    key: 'addEvent',
    value: function addEvent(group, callback) {
      this.events[group] = this.events[group] || [];

      this.events[group].push(callback);
    }
  }, {
    key: 'addEventMarker',
    value: function addEventMarker(marker, data) {
      this.eventMarkers[marker] = this.eventMarkers[marker] || [];
      this.eventMarkers[marker].push(data);
    }
  }, {
    key: 'extractPreloadEvents',
    value: function extractPreloadEvents(data) {
      var _this2 = this;

      var preloadEvents = data && data[FIREALARM_PREOADED_EVENTS_KEY] ? data[FIREALARM_PREOADED_EVENTS_KEY] : {};

      _EventGroups2.default.keys().forEach(function (key) {
        var group = _EventGroups2.default[key];

        if (preloadEvents[group] && Array.isArray(preloadEvents[group])) {
          preloadEvents[group].map(function (callback) {
            _this2.addEvent(group, callback);
          });
        }
      });
    }
  }, {
    key: 'runEvents',
    value: function runEvents(eventGroup, data) {
      var eventData = {
        eventGroup: eventGroup,
        data: data
      };

      if (this.events[eventGroup]) {
        switch (eventGroup) {
          case _EventGroups2.default.eventGroups.CREATE_ALARM:
            {
              this.events[eventGroup].map(function (alarmData) {
                data.addAlarm(alarmData);
              });
              break;
            }
          default:
            {
              this.events[eventGroup].map(function (callback) {
                callback(eventData);
              });
            }
        }
      }

      this.addEventMarker(eventGroup, eventData);
    }
  }]);

  return Events;
}();

exports.default = Events;
module.exports = exports['default'];